import React from "react";
import { useNavigate } from "react-router-dom";

export default function ButtonPrimary(props) {
  const navigate = useNavigate();
  function handleClick(e) {
    props.to ? navigate(props.to) : props.onclick(e);
  }
  return (
    <>
      <button onClick={handleClick} type="button" className="btn btn-primary">
        {props.value}
      </button>
    </>
  );
}
